export function useNow(): Date {
    return new Date()
}
